







import Vue from 'vue';
import SkillSearch from "@/components/skill/SkillSearch.vue";

//  SkillSearch owns its own URL state (every filter key, not just the name),
//  so this view no longer round-trips the query through a prop and an event.
export default Vue.extend({
    components: {
        SkillSearch,
    },
});
